module.exports = {
      id: "comm-sports-usage",
      viewBox: "0 0 411.122 51.012",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-sports",
      toString: function () {
        return this.url;
      }
    }